<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form" v-show="emailreq || isDev">
      <h1 class="auth-title mb-6">Potwierdź e-mail</h1>

      <validation-observer v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(login)"
          method="post"
          id="wk"
          ref="wk"
          :action="action"
          novalidate
          autocomplete="off"
        >
          <input
            hidden
            value="wktemailreq"
            name="wktemailreq"
            autocomplete="off"
          />
          <input hidden :value="wkt" name="username" autocomplete="off" />
          <input hidden :value="regulation" name="req" autocomplete="off" />
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            name="e-mail"
          >
            <!-- password celowy zabieg -->
            <v-text-field
              v-model="email"
              label="E-mail"
              placeholder="E-mail"
              name="email"
              :error-messages="errors"
              required
              outlined
              persistent-placeholder
              background-color="white"
              class="mb-2"
              autocomplete="off"
            />
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email|confirmed:e-mail"
            name="Powtórz e-mail"
          >
            <v-text-field
              v-model="confirmedEmail"
              label="Powtórz e-mail"
              placeholder="Powtórz e-mail"
              :error-messages="errors"
              required
              outlined
              persistent-placeholder
              background-color="white"
              class="mb-2"
              autocomplete="nope"
            />
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            :rules="passwordRules"
            name="Hasło"
          >
            <v-text-field
              title="Uzupełnij to pole"
              v-model="password"
              :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye-off'"
              @click:append="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              label="Hasło"
              placeholder="Hasło"
              name="password"
              :error-messages="errors"
              required
              outlined
              persistent-placeholder
              autocomplete="new-password"
              background-color="white"
              class="mb-2"
            />
          </ValidationProvider>

          <ValidationProvider
            name="Powtórz hasło"
            rules="required"
            v-slot="{ failed }"
          >
            <v-text-field
              title="Uzupełnij to pole"
              v-model="repeatPassword"
              :append-icon="e2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e2 = !e2)"
              :type="e2 ? 'password' : 'text'"
              label="Powtórz hasło"
              placeholder="Powtórz hasło"
              name="repeat_password"
              :error="failed"
              required
              outlined
              persistent-placeholder
              autocomplete="new-password"
              background-color="white"
              class="mb-2"
            />
          </ValidationProvider>

          <div v-for="r in regulations" :key="r.regulationId">
            <ValidationProvider :rules="r.rules" v-slot="{ failed }">
              <v-checkbox
                v-model="regulation"
                persistent-hint
                :value="r.regulationId"
                :error="failed"
              >
                <template v-slot:label>
                  <div>
                    <div
                      v-if="r.shortContent.includes('href')"
                      class="ma-0"
                      @click.stop
                      v-html="r.shortContent"
                      title="Kliknij w link, aby otworzyć tą stronę"
                    />
                    <div
                      v-else
                      class="ma-0"
                      @click.stop
                      :title="tooltip.checkbox"
                      v-html="r.shortContent"
                    ></div>
                  </div>
                </template>
              </v-checkbox>
            </ValidationProvider>
          </div>

          <LoginAlerts
            :show="show"
            :type="color"
            :msg="text"
            @close="show = false"
            dismissible
          />
          <div class="actions">
            <div class="actions_links">
              <LibBtnSimple
                color="primary"
                text="Wróć do logowania"
                rounded
                underline
                title="Wróć do logowania"
                :to="{ name: 'Login' }"
                class="mr-3"
              />

              <v-btn
                type="submit"
                title="Kliknij, aby zalogować się do Cyfrowej Książki Obiektu Budowlanego"
                large
                color="primary"
                rounded
                depressed
              >
                Potwierdź e-mail
              </v-btn>
            </div>
          </div>
        </form>
      </validation-observer>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import LoginAlerts from "../components/LoginAlerts.vue";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, email, regex, confirmed } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

setInteractionMode("lazy");
extend("required", { ...required, message: "Pole jest wymagane" });
extend("confirmed", {
  ...confirmed,
  message: "Adresy e-mail muszą być identyczne"
});
extend("email", {
  ...email,
  message: "Wprowadź poprawny adres e-mail"
});
extend("contains", {
  validate(value, args) {
    const val = args.value;
    return !!value.find((v) => v == val);
  },
  params: ["value"]
});
export default {
  name: "LoginWK",
  components: {
    ValidationProvider,
    ValidationObserver,
    LoginAlerts,
    LibBtnSimple
  },
  data() {
    return {
      action: process.env.VUE_APP_AUTH_REST_URL + "/login",
      timeout: 10000,
      text: "Niepoprawne dane logowania",
      color: "error",
      show: false,
      email: "",
      emailreq: false,
      wkt: null,
      errors: null,
      regulation: [],
      regulations: [],
      password: null,
      repeatPassword: null,
      confirmedEmail: "",
      passwordRulesBase: {
        required: true,
        password: { target: "@Powtórz hasło" }
      },
      e1: true,
      e2: true
    };
  },
  computed: {
    isDev() {
      return process.env.VUE_APP_WK === "false";
    },
    passwordRules() {
      const param = this.$store.getters["conf/getConfigurationParam"](
        "password.strength"
      );

      if (param) {
        extend("regex", {
          ...regex,
          message: param.description
        });
        return Object.assign({}, this.passwordRulesBase, {
          regex: param.value
        });
      }
      return this.passwordRulesBase;
    }
  },
  metaInfo: {
    title: "Logowanie do c-KOB"
  },
  methods: {
    login() {
      document.getElementById("wk").submit();
    },
    loadRegulation() {
      return axios
        .get(`${process.env.VUE_APP_AUTH_REST_URL}/regulation`)
        .then(({ data }) => {
          return data;
        });
    }
  },
  mounted() {
    if (this.$route.query.wk) {
      if (!this.emailreq) document.getElementById("wk").submit();
    }
    if (this.$route.query.error) {
      this.text = decodeURIComponent(this.$route.query.error);
      this.color = "error";
      this.show = true;
    }
  },
  created() {
    this.wkt = this.$route.query.wk;
    this.emailreq = this.$route.query.emailreq === "true";
    this.loadRegulation().then((reg) => {
      this.regulations = reg.map((r) => {
        if (r.mustConfirm == true)
          r.rules = `required|contains:${r.regulationId}`;
        return r;
      });
    });
  }
};
</script>
